module.exports = {
  // debug: process.env.NODE_ENV === 'development',
  i18n: {
    defaultLocale: 'en',
    locales: ['en', 'fr-CA', 'cy'],
  },
  fallbackLng: 'en',
  localePath: './public/locales',
  keySeparator: false,
  defaultNS: 'common',
  detection: {
    order: ['cookie', 'htmlTag'],
  },
  browserLanguageDetection: true,
  serverLanguageDetection: true,
  // reloadOnPrerender: process.env.NODE_ENV === 'development',
};

/**
 * Below code is needed when we move to CDN approach
 */

// const isServer = typeof window === 'undefined';

// module.exports = {
//   i18n: {
//     defaultLocale: 'en',
//     locales: ['en', 'fr-CA', 'cy'],
//   },
//   fallbackLng: 'en',
//   defaultNS: 'common',
//   keySeparator: false,
//   detection: {
//     order: ['cookie', 'htmlTag'],
//     caches: ['cookie'],
//   },
//   serializeConfig: false,
//   browserLanguageDetection: true,
//   serverLanguageDetection: true,
//   backend: {
//     loadPath: isServer
//       ? 'https://dclta3xaji7vg.cloudfront.net/locales/{{lng}}/{{ns}}.json'
//       : '/locales/{{lng}}/{{ns}}.json',
//     // You can specify multiple namespaces in your app, e.g. ['common', 'admin-layout']
//     // i18next will automatically load all required namespaces for the current page/component
//   },
//   use: isServer ? [require('i18next-http-backend')] : [],
// };
